export enum FileTransactionStatusEnum {
  ready,
  preparing,
  in_progress,
  finished,
  confirmed,
  error,
  canceled
}
